import "vite/modulepreload-polyfill";
import "./index.css";

import { VueQueryPlugin } from "@tanstack/vue-query";
import axios from "axios";
import { createPinia } from "pinia";
import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";

import PlaygroundApp from "./playground/PlaygroundApp.vue";
import { useStore as useScaffoldingStore } from "./store/stores/scaffolding";

// Create minimal pinia store
const pinia = createPinia();

const router = createRouter({
  history: createWebHistory(),
  routes: [],
});

// Create the Vue app
const app = createApp(PlaygroundApp);

app.use(router);

// Fix CSRF.
axios.defaults.xsrfHeaderName = "X-CSRFToken";

// Add API token to all outgoing requests.
axios.interceptors.request.use(
  (config) => {
    const scaffoldingStore = useScaffoldingStore();
    if (!scaffoldingStore.newsletter) {
      return config;
    }
    const token = scaffoldingStore.newsletter.api_key;
    if (token != null) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// Configure Vue Query
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        gcTime: 5 * 60_000, // 5 minutes
        staleTime: 30_000, // 30 seconds
        // Disable all queries in playground mode
        enabled: false,
      },
    },
  },
});

app.use(pinia);

window.HYDRATED_PAYLOAD = {};
window.DEBUG = false;

app.mount("#app");

export default app;